define('modules/ads/ads_view',[
  'backbone',
  'jquery',
  '_',
  'session',
  'URIjs/URI',
  './ads_collection',
  './ad_model',
  'modules/list/list_view',
  'modules/loading/loading_spinner_view',
  'modules/pagination/pagination_view',
  'modules/order_table/order_table',
  'modules/htmlad/player/htmlad_player_view',
  'modules/modal/modal_view',
  'text!./ads_template.html',
  'text!./ads_header_template.html',
  'text!./ad_list_item_template.html',
  './modals/archive_ads_modal',
  'modules/content_recommendations/modal/play_modal',
  'modules/content_recommendations/modal/pause_modal',
], function (
  Backbone,
  $,
  _,
  session,
  URI,
  AdsCollection,
  AdModel,
  ListView,
  Loading,
  PaginationView,
  orderTable,
  HtmlAdPlayer,
  ModalView,
  ads_template,
  ads_header_template,
  ad_list_item_template,
  ArchiveAdsModal,
  PlayModal,
  PauseModal
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.pagination = false;
      this.collection = false;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = new AdsCollection();

      this.listenTo(this.collection, 'request', loading.start.bind(loading));

      this.listenTo(
        this.collection,
        'destroy',
        function (collection) {
          loading.done();
        },
        this
      );

      this.listenTo(
        this.collection,
        'sync',
        function (collection) {
          loading.done();
          this.renderHeader();
          this.renderList();
          this.renderPagination();
        },
        this
      );

      this.collection.params = _.extend(
        this.collection.params,
        URI.parseQuery(this.params)
      );
      this.collection.params = _.extend(this.collection.params, {
        location_id: session.get('location_id'),
      });

      if (this.with_zone) {
        this.collection.params = _.extend(this.collection.params, {
          exclude_zone: this.zone_id,
        });
      }

      this.collection.fetch();

      Backbone.on('ads:archive', this.archiveAds, this);
      Backbone.on('changeItemsStatusAds', this.changeItemsStatusAds, this);
    },

    with_zone: false,

    hasSidebar: false,
    subViews: [],

    template: _.template(ads_template),
    header_template: _.template(ads_header_template),
    item_template: _.template(ad_list_item_template),

    events: {
      'click .ads-header-item [data-order-by]': 'orderTableHandler',
      'click .js-connect-item': 'connectAdToZone',
      'click .js-preview-item': 'previewMode',
      'click .js-header-checkbox': 'selectAllAds',
      'click .js-item-checkbox': 'onSelectAd',
      'click .js-header-archive': 'onArchive',
      'click .js-header-unarchive': 'onUnarchive',
      'click .js-header-play-selected': 'playSelectedItems',
      'click .js-header-pause-selected': 'pauseSelectedItems',
      'click .js-item-play': 'playItem',
      'click .js-item-pause': 'pauseItem',
    },

    orderTableHandler: function (e) {
      e.preventDefault();
      orderTable($(e.currentTarget), this.collection);
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderHeader: function (payload) {
      var params = _.extend(this.collection.params, {
        with_zone: this.with_zone,
        isChecked: payload ? payload.isChecked : false,
        numberOfItems: payload ? payload.numberOfItems : 0,
        buttons: {
          archive: this.collection.params.period === 'ended',
          unarchive: this.collection.params.period === 'archived',
          play: true,
          pause: true,
        },
      });
      this.$('.js-ads-header').html(this.header_template(params));
      return this;
    },

    renderList: function () {
      var items = [],
        adList;

      this.collection.each(function (model) {
        if (!model.get('isChecked')) {
          model.set('isChecked', false);
        }
        items.push({
          model: model,
          value: this.item_template(
            _.extend(model.toJSON(), {
              with_zone: this.with_zone,
              show_checkbox:
                this.collection.params.period === 'ended' ||
                this.collection.params.period === 'archived',
            })
          ),
        });
      }, this);

      adList = new ListView({
        items: items,
        className: 'list ads-list',
      });

      this.$('.js-ads-list').html(adList.$el);

      this.subViews.push(adList);

      return this;
    },

    connectAdToZone: function (e) {
      var $ad, ad_id;

      e.preventDefault();

      $ad = $(e.currentTarget).closest('.ads-items');
      ad_id = $ad.data('id');

      $.ajax({
        type: 'POST',
        contentType: 'application/json; charset=UTF-8',
        url:
          session.get('apiUrl') +
          'htmladlocation/' +
          ad_id +
          '/addzone/' +
          this.zone_id,
      }).success(
        function (data) {
          $ad.fadeOut();
        }.bind(this)
      );
    },

    previewMode: function (e) {
      var self = this,
        $ad,
        ad_id,
        adModel;

      e.preventDefault();

      $ad = $(e.currentTarget).closest('.ads-items');
      ad_id = $ad.data('id');

      adModel = new AdModel({ id: ad_id });

      this.listenToOnce(
        adModel,
        'sync',
        function (model) {
          var previewModel,
            htmlAdPlayer,
            htmlAdModel =
              model.get('htmlad') || model.get('htmlad_multiple_sections');
          previewModel = new Backbone.Model({
            name: htmlAdModel.title,
            preview: htmlAdModel.preview_url,
            metadata: {
              orientations: htmlAdModel.orientations,
            },
          });
          htmlAdPlayer = new HtmlAdPlayer({
            model: previewModel,
            fitHeight: 600,
            close: function () {
              self.$('.js-preview-iframe').removeClass('ad-preview').empty();
              this.remove();
            },
          });
          this.$('.js-preview-iframe')
            .html(htmlAdPlayer.$el)
            .addClass('ad-preview');

          //toggle buttons
          this.$('.js-preview-htmlad').addClass('is-hidden');
          this.$('.js-edit-htmlad').removeClass('is-hidden');

          // toggle form
          this.$('.js-form-content').addClass('is-hidden');
          // and buttons
          this.$('.form-buttons').addClass('is-hidden');
        },
        this
      );

      adModel.fetch();
    },

    onSelectAd: function (e) {
      // Used for setting the isChecked true/false for the add/remove modal
      var targetModel = this.collection.find(function (model) {
        return model.get('id') == e.currentTarget.dataset.id;
      });
      targetModel.set('isChecked', !targetModel.get('isChecked'));

      var numberItemChecked = 0;

      _.forEach($('.js-item-checkbox'), function (inputElement) {
        if (inputElement.checked) {
          numberItemChecked++;
        }
      });

      // Update allSelect checkbox state
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) {
        return;
      }
      headerCheckbox.prop('checked', numberItemChecked >= 1);

      var payload = {
        isChecked: numberItemChecked >= 1,
        numberOfItems: numberItemChecked,
      };

      this.renderHeader(payload);
    },

    selectAllAds: function () {
      var headerCheckbox = $('.js-header-checkbox');
      if (!headerCheckbox) {
        return;
      }

      var isChecked = headerCheckbox.prop('checked'); //= !headerCheckbox.checked;

      this.collection.each(function (model) {
        model.set('isChecked', isChecked);
      }, this);

      _.forEach($('.js-item-checkbox'), function (inputElement) {
        inputElement.checked = isChecked;
      });

      // Not going to renderList because it rerenders everything and causes a flash
      // this.renderList();

      var payload = {
        isChecked: isChecked,
        numberOfItems: this.collection.length,
      };

      this.renderHeader(payload);
    },

    onArchive: function (e) {
      e.preventDefault();

      var modalView = new ModalView({
        title: _.t('my_ads.modal.archive.title'),
        modalContent: new ArchiveAdsModal({
          archive: true,
        }),
        bottom_toolbar: false,
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    onUnarchive: function (e) {
      e.preventDefault();

      var modalView = new ModalView({
        title: _.t('my_ads.modal.unarchive.title'),
        modalContent: new ArchiveAdsModal({
          archive: false,
        }),
        bottom_toolbar: false,
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    archiveAds: function (value) {
      var that = this;
      var loading = new Loading();
      this.subViews.push(loading);
      loading.start();

      var selectedAdIds = [];
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          selectedAdIds.push(parseInt(element.dataset.id));
        }
      });

      var string = value === true ? 'archive' : 'unarchive';

      $.ajax({
        type: 'POST',
        url: session.get('apiUrl') + 'htmladlocation/' + string,
        data: JSON.stringify({
          Booking_Ids: selectedAdIds,
        }),
        contentType: 'application/json',
      })
        .success(
          function (data) {
            loading.done();
            that.collection.fetch();
          }.bind(this)
        )
        .error(
          function (error) {
            loading.done();
          }.bind(this)
        );
    },

    playSelectedItems: function (e) {
      e.preventDefault();
      var selectedBookingIds = [];
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          selectedBookingIds.push(parseInt(element.dataset.id));
        }
      });
      this.openPlayModal(selectedBookingIds);
    },

    pauseSelectedItems: function (e) {
      e.preventDefault();
      var selectedBookingIds = [];
      _.forEach($('.js-item-checkbox'), function (element) {
        if (element.checked) {
          selectedBookingIds.push(parseInt(element.dataset.id));
        }
      });
      this.openPauseModal(selectedBookingIds);
    },

    playItem: function (e) {
      e.preventDefault();
      var bookingIds = [];
      bookingIds.push(
        parseInt(e.currentTarget.getAttribute('data-booking-id'))
      );
      this.openPlayModal(bookingIds);
    },

    pauseItem: function (e) {
      e.preventDefault();
      var bookingIds = [];
      bookingIds.push(
        parseInt(e.currentTarget.getAttribute('data-booking-id'))
      );
      this.openPauseModal(bookingIds);
    },

    openPlayModal: function (bookingIds) {
      var modal = new ModalView({
        title: _.t('content_recommendations.play_modal.title'),
        modalContent: new PlayModal({
          bookingIds: bookingIds,
          type: 'ads',
        }),
        bottom_toolbar: false,
      });
      modal.open();
    },

    openPauseModal: function (bookingIds) {
      var modal = new ModalView({
        title: _.t('content_recommendations.pause_modal.title'),
        modalContent: new PauseModal({
          bookingIds: bookingIds,
          type: 'ads',
        }),
        bottom_toolbar: false,
      });
      modal.open();
    },

    changeItemsStatusAds: function (bookingIds, shouldPlay) {
      var collection = this.collection;
      var bookingFinder = function (bookingId) {
        return collection.find(function (model) {
          return model.get('id') === bookingId;
        });
      };
      $.ajax({
        type: 'PUT',
        url: session.get('apiUrl') + 'campaignstatuses',
        data: { bookingIds: bookingIds, isPlaying: shouldPlay },
        dataType: 'json',
      })
        .success(
          function (data) {
            for (var i = 0; i < data.length; i++) {
              var booking = bookingFinder(data[i].bookingId);

              var bookingDiv = document.querySelector(
                '[data-id="' + data[i].bookingId + '"]'
              );

              if (data[i].broadcastStatus) {
                var broadcastStatus =
                  bookingDiv.querySelectorAll('.ads-column-grid ');
                for (var j = 0; j < broadcastStatus.length; j++) {
                  if (
                    broadcastStatus[j].getAttribute('data-broadcastStatus') === data[i].broadcastStatus
                  ) {
                    broadcastStatus[j].classList.remove('hide');
                  } else {
                    broadcastStatus[j].classList.add('hide');
                  }
                }
                booking.set('broadcastStatus', data[i].bookingId);
              }
            }
          }.bind(this)
        )
        .error(
          function (error) {
            this.fetchOffers();
          }.bind(this)
        );
    },

    renderPagination: function () {
      if (this.pagination) {
        this.pagination.remove();
      }

      this.pagination = new PaginationView(this.collection);
      this.subViews.push(this.pagination);

      this.$el.append(this.pagination.$el);
      this.pagination.delegateEvents();
    },

    remove: function () {
      Backbone.off('ads:archive');
      Backbone.off('changeItemsStatusAds');
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

